module.exports = __webpack_public_path__ + "media/images/chevron_down_icon-81b9c9ef.svg";